import { createContext } from "react";
import { DemandWalkEditsContextType } from "./type";

export const DemandWalkEditsContext = createContext<DemandWalkEditsContextType>(
  {
    // Demand walk specific state
    plannerOverrideInputs: {},
    finalForecastInputs: {},
    yoyPercentageInputs: {},

    // Edit state (moved from LayoutContext)
    editMode: false,

    // Loading state from mutations
    loading: false,

    // State setters
    setPlannerOverrideInputs: () => {},
    setFinalForecastInputs: () => {},
    setYoYPercentageInputs: () => {},

    // Convenience methods for edit state
    setEditMode: () => {},
    saveEditsAndTriggerRun: async () => {},

    // Actions
    discardChanges: () => {},
  }
);
